class UploadResource {
    public static $inject: string[] = [
        "$resource",
        "configService"
    ];

    constructor(
        $resource,
        configService
    ) {
        return (headers, formData) => {
            return $resource(configService.uploadApi.url + "/v1/upload", {}, {
                create: {
                    method: "POST",
                    headers: headers || {},
                    transformRequest: () => {
                        return formData;
                    }
                }
            });
        };
    }

}

angular
    .module("thor.core.upload.resource", [])
    .factory("uploadResource", UploadResource);
